import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IntakeSession } from './intake-session';

export const firmSlugGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const intakeSession = inject(IntakeSession);

  let firmSlug = route.queryParams['firm'];

  if (!firmSlug) {
    firmSlug = intakeSession.firmSlug();
  }

  if (!firmSlug) {
    return router.createUrlTree(['/error'], { queryParams: { reason: 'missing-firm' } });
  }

  return true;
};
